import { render } from "./logo-shopeepay.svg?vue&type=template&id=68b87c04"
const script = {}
script.render = render

export default script